import { supabase } from '../../../services/supabaseClient';

const MF_TOKEN = 'QOQMRWtDQA9W8pluLNSV';
const TABLE = 'bianca_realestate_corretores';

async function fetchCorretor(authUserId, email) {
  // Apos aprovacao, o backend faz UPDATE corretores.id = auth.users.id.
  // Entao id == auth.uid() pra corretores aprovados.
  // Pra robustez, tenta por id primeiro e cai pro email se falhar.
  if (authUserId) {
    const { data } = await supabase
      .from(TABLE).select('*').eq('id', authUserId).eq('token', MF_TOKEN).maybeSingle();
    if (data) return data;
  }
  if (email) {
    const { data } = await supabase
      .from(TABLE).select('*').eq('token', MF_TOKEN).ilike('email', email.toLowerCase()).maybeSingle();
    if (data) return data;
  }
  return null;
}

export async function signInCorretor(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });
  if (error) return { ok: false, error: 'Email ou senha incorretos.' };

  const corretor = await fetchCorretor(data.user?.id, data.user?.email);
  if (!corretor) {
    await supabase.auth.signOut();
    return { ok: false, error: 'Cadastro nao encontrado. Entre em contato com a equipe MF.' };
  }
  if (corretor.status !== 'aprovado') {
    await supabase.auth.signOut();
    if (corretor.status === 'pendente') return { ok: false, error: 'Seu cadastro ainda nao foi aprovado.' };
    if (corretor.status === 'rejeitado') return { ok: false, error: 'Seu cadastro foi rejeitado. ' + (corretor.motivo_rejeicao || '') };
    if (corretor.status === 'suspenso') return { ok: false, error: 'Sua conta esta suspensa. Fale com a equipe MF.' };
    return { ok: false, error: 'Status invalido. Fale com a equipe MF.' };
  }
  return { ok: true, corretor };
}

export async function signOutCorretor() {
  await supabase.auth.signOut();
}

export async function getCurrentCorretor() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null;
  const corretor = await fetchCorretor(session.user?.id, session.user?.email);
  if (!corretor || corretor.status !== 'aprovado') return null;
  return { session, corretor };
}

export function onCorretorAuthChange(callback) {
  const { data } = supabase.auth.onAuthStateChange((event, session) => callback(event, session));
  return () => data.subscription?.unsubscribe();
}

export async function requestCorretorPasswordReset(email) {
  const redirectTo = `${window.location.origin}/corretor/set-password`;
  const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}

export async function setCorretorPassword(newPassword) {
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
